import { Paper } from '@mantine/core';
import { MapMouseEvent } from 'mapbox-gl';
import { FC, useCallback, useState } from 'react';

import { parseResultsMapFeaturePopup } from '../lib/parse-results-map-feature';

import { ResultsFieldPopup, ResultsFieldPopupData } from './results-field-popup';
import {
  RESULTS_INTERACTIVE_LAYER_IDS,
  ResultsMapInBounds,
} from './results-map-in-bounds';

import { PfMap } from '@map';

/**
 * Global map view for the results list.
 * Uses api/results/map/ with bbox, cluster, zoom (same contract as plotmap).
 */
export const ResultsListMap: FC = () => {
  const [popupData, setPopupData] = useState<ResultsFieldPopupData | null>(
    null,
  );

  const handleMapClick = useCallback((event: MapMouseEvent) => {
    const features = event.target.queryRenderedFeatures(event.point, {
      layers: RESULTS_INTERACTIVE_LAYER_IDS,
    });

    if (features.length > 0 && event.lngLat) {
      const props = features[0].properties as Record<string, unknown> | undefined;
      if (props) {
        setPopupData(parseResultsMapFeaturePopup(props, event.lngLat));
        return;
      }
    }
    setPopupData(null);
  }, []);

  return (
    <Paper h="100%" p={0} style={{ overflow: 'hidden' }} withBorder>
      <PfMap
        interactiveLayerIds={RESULTS_INTERACTIVE_LAYER_IDS}
        onClick={handleMapClick}
      >
        <ResultsMapInBounds />
        {popupData && (
          <ResultsFieldPopup
            data={popupData}
            onClose={() => setPopupData(null)}
          />
        )}
      </PfMap>
    </Paper>
  );
};
